function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcCoberturasInactive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 23 23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ic") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 23,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9,1.41a.93.93,0,0,0-.8,0L3.65,4.72a1.07,1.07,0,0,0-.65,1v5a11.49,11.49,0,0,0,8.22,11,1.06,1.06,0,0,0,.56,0,11.49,11.49,0,0,0,8.22-11v-5a.94.94,0,0,0-.55-.85Zm6.33,4.47a.43.43,0,0,1,.25.38v4.4a10,10,0,0,1-7,9.53,10,10,0,0,1-7-9.53V6.59a.91.91,0,0,1,.54-.84L11.3,3a.47.47,0,0,1,.4,0Z",
    style: {
      fill: "#8a8a8a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.05,15.18,6.88,13a.85.85,0,0,1,0-1.23h0a.88.88,0,0,1,1.23,0l1.51,1.51a.2.2,0,0,0,.27,0l5-5a.88.88,0,0,1,1.24,0h0a.87.87,0,0,1,0,1.23l-5.67,5.67A1,1,0,0,1,9.05,15.18Z",
    style: {
      fill: "#8a8a8a"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCoberturasInactive);
export default __webpack_public_path__ + "static/media/ic-coberturas-inactive.877a9a99442668bf84a2939d852058ed.svg";
export { ForwardRef as ReactComponent };